// src/Components/Functions/pdfUtils.js
import html2pdf from 'html2pdf.js';

// src/Components/Functions/PdfGenerator.js
export const exportToPdf = async (contentRef, options = {}) => {
    const {
      fileName = 'exported_document',
      title = 'Document',
      subtitle = '',
      margin = [15, 10],
      format = 'a3',
      orientation = 'landscape',
      scale = 2,
    } = options;
  
    if (!contentRef || !contentRef.current) {
      console.error('Invalid or missing content reference', contentRef);
      return false;
    }
  
    try {
      const pdfContainer = document.createElement('div');
      pdfContainer.style.backgroundColor = 'white';
      pdfContainer.style.padding = '20px';
  
      const header = document.createElement('div');
      header.innerHTML = `
        <h1 style="font-size: 24px; margin-bottom: 16px;">${title}</h1>
        ${subtitle ? `<p style="margin-bottom: 16px;">${subtitle}</p>` : ''}
      `;
      pdfContainer.appendChild(header);
  
      const content = contentRef.current.cloneNode(true);
      console.log('Content being exported:', content.outerHTML); // Debug content
  
      const tables = content.querySelectorAll('table');
      tables.forEach((table) => {
        table.style.width = '100%';
        table.style.fontSize = '10px';
        table.style.borderCollapse = 'collapse';
        const cells = table.querySelectorAll('td, th');
        cells.forEach((cell) => {
          cell.style.border = '1px solid #e5e7eb';
          cell.style.padding = '8px';
        });
      });
  
      pdfContainer.appendChild(content);
  
      const pdfOptions = {
        margin,
        filename: `${fileName}_${new Date().toISOString().slice(0, 10)}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale,
          logging: true, // Enable for more debug info
          useCORS: true,
          letterRendering: true,
        },
        jsPDF: {
          unit: 'mm',
          format,
          orientation,
        },
      };
  
      document.body.appendChild(pdfContainer);
      await html2pdf().set(pdfOptions).from(pdfContainer).save();
      document.body.removeChild(pdfContainer);
      return true;
    } catch (error) {
      console.error('PDF Generation Error:', error.stack);
      return false;
    }
  };